export interface FieldTag {
  id: string;
  label: string;
  description?: string;
  color?: string;
  icon?: string;
  category?: string;
  metadata?: Record<string, unknown>;
}

export const STANDARD_FIELD_TAGS: FieldTag[] = [
  {
    id: 'demographics',
    label: 'Demographics',
    description: 'Basic demographic information',
    color: '#3B82F6',
    icon: 'Users',
    category: 'core',
  },
  {
    id: 'medical',
    label: 'Medical',
    description: 'Health and medical information',
    color: '#EF4444',
    icon: 'Heart',
    category: 'specialized',
  },
  {
    id: 'genetic',
    label: 'Genetic',
    description: 'Genetic and hereditary information',
    color: '#8B5CF6',
    icon: 'Dna',
    category: 'specialized',
  },
  {
    id: 'mental-health',
    label: 'Mental Health',
    description: 'Mental health and psychological information',
    color: '#EC4899',
    icon: 'Brain',
    category: 'specialized',
  },
  {
    id: 'legal',
    label: 'Legal',
    description: 'Legal status and documentation',
    color: '#F59E0B',
    icon: 'Scale',
    category: 'specialized',
  },
  {
    id: 'financial',
    label: 'Financial',
    description: 'Financial and estate information',
    color: '#10B981',
    icon: 'DollarSign',
    category: 'specialized',
  },
  {
    id: 'social',
    label: 'Social',
    description: 'Social services and support information',
    color: '#06B6D4',
    icon: 'Users2',
    category: 'specialized',
  },
  {
    id: 'education',
    label: 'Education',
    description: 'Educational background and status',
    color: '#6366F1',
    icon: 'GraduationCap',
    category: 'core',
  },
  {
    id: 'employment',
    label: 'Employment',
    description: 'Employment and occupation information',
    color: '#8B5CF6',
    icon: 'Briefcase',
    category: 'core',
  },
  {
    id: 'relationships',
    label: 'Relationships',
    description: 'Relationship dynamics and emotional bonds',
    color: '#F43F5E',
    icon: 'Heart',
    category: 'therapy',
  },
  {
    id: 'therapy',
    label: 'Therapy',
    description: 'Therapeutic interventions and treatment',
    color: '#14B8A6',
    icon: 'Stethoscope',
    category: 'therapy',
  },
  {
    id: 'research',
    label: 'Research',
    description: 'Research and data collection fields',
    color: '#64748B',
    icon: 'FlaskConical',
    category: 'research',
  },
  {
    id: 'cultural',
    label: 'Cultural',
    description: 'Cultural background and heritage',
    color: '#F97316',
    icon: 'Globe',
    category: 'core',
  },
  {
    id: 'lifestyle',
    label: 'Lifestyle',
    description: 'Lifestyle factors and habits',
    color: '#84CC16',
    icon: 'Activity',
    category: 'core',
  },
  {
    id: 'contact',
    label: 'Contact',
    description: 'Contact and location information',
    color: '#06B6D4',
    icon: 'MapPin',
    category: 'core',
  },
  {
    id: 'notes',
    label: 'Notes',
    description: 'Additional notes and observations',
    color: '#94A3B8',
    icon: 'FileText',
    category: 'core',
  },
  {
    id: 'timeline',
    label: 'Timeline',
    description: 'Important dates and timeline events',
    color: '#A855F7',
    icon: 'Calendar',
    category: 'core',
  },
  {
    id: 'risk-factors',
    label: 'Risk Factors',
    description: 'Risk assessment and protective factors',
    color: '#DC2626',
    icon: 'AlertTriangle',
    category: 'specialized',
  },
];
